import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import { getSelectedSegment } from '../../../reducers/analyticsApp';
import { isStepEnabled } from '../../../utils/compound';
import {
  defaultCompoundStepCount,
  defaultCompoundStepCountOperator,
} from '../../../constants/compound';
import CompoundExecutionStepDetails from '../../../components/compound/execution/StepDetails';

const SegmentExecutionDetails = ({ steps, perStepClosingRangeEnabled }) => (
  <div>
    {steps.map((step, i) => (
      <CompoundExecutionStepDetails
        stepNum={i + 1}
        stepCount={null}
        stepEvent={step.event}
        stepType={step.type}
        stepFilter={step.filter}
        stepDescription={step.descriptionVisible && step.description}
        stepClosingRange={perStepClosingRangeEnabled && i ? step.closingRange : undefined}
        stepRequiredCount={step.count || defaultCompoundStepCount}
        stepRequiredCountOperator={step.countOperator || defaultCompoundStepCountOperator}
        disabled={!isStepEnabled(step.enabled)}
        key={v4()}
        optional={step.optional}
      />
    ))}
  </div>
);

const mapStateToProps = (state) => {
  const segment = getSelectedSegment(state);

  return {
    steps: segment.steps,
    perStepClosingRangeEnabled: true,
  };
};

export default connect(mapStateToProps)(SegmentExecutionDetails);
